import actions from './actions';


const { 
    STORE_DASHBOARD_DATA_BEGIN, STORE_DASHBOARD_DATA_SUCCESS, STORE_DASHBOARD_DATA_ERR, 
    SPL_PRODUCT_TARGET_BEGIN, SPL_PRODUCT_TARGET_SUCCESS, SPL_PRODUCT_TARGET_ERR,
    GET_PRODUCT_DISCOVERY_TOKEN_BEGIN, GET_PRODUCT_DISCOVERY_TOKEN_SUCCESS, GET_PRODUCT_DISCOVERY_TOKEN_ERR,
    STORE_CONTENT_VIDEO_DETAILS_BEGIN, STORE_CONTENT_VIDEO_DETAILS_SUCCESS, STORE_CONTENT_VIDEO_DETAILS_ERR,
    STORE_CONTENT_VIDEO_DOWNLOAD_BEGIN, STORE_CONTENT_VIDEO_DOWNLOAD_SUCCESS, STORE_CONTENT_VIDEO_DOWNLOAD_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

const storeDashboardDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case STORE_DASHBOARD_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case STORE_DASHBOARD_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case STORE_DASHBOARD_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

const splProductTargetReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SPL_PRODUCT_TARGET_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SPL_PRODUCT_TARGET_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case SPL_PRODUCT_TARGET_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

const initialTokenState = { token: null, loading: false, error: null };

const productDiscoveryTokenReducers = (state = initialTokenState, action) => {
    const { type, token, err } = action;
    switch (type) {
        case GET_PRODUCT_DISCOVERY_TOKEN_BEGIN:
            return {
                ...initialTokenState,
                loading: true,
            };
        case GET_PRODUCT_DISCOVERY_TOKEN_SUCCESS:
            return {
                ...initialTokenState,
                token,
                error: null,
                loading: false,
            };
        case GET_PRODUCT_DISCOVERY_TOKEN_ERR:
            return {
                ...initialTokenState,
                error: err,
                token: null,
                loading: false,
            };
        default:
            return state;
    }
};

const storeContentVideoDetailsReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case STORE_CONTENT_VIDEO_DETAILS_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case STORE_CONTENT_VIDEO_DETAILS_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error: null,
                loading: false,
            };
        case STORE_CONTENT_VIDEO_DETAILS_ERR:
            return {
                ...initialStateArray,
                error: err,
                data: null,
                loading: false,
            };
        default:
            return state;
    }
};

const storeContentVideoDownloadReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case STORE_CONTENT_VIDEO_DOWNLOAD_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case STORE_CONTENT_VIDEO_DOWNLOAD_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error: null,
                loading: false,
            };
        case STORE_CONTENT_VIDEO_DOWNLOAD_ERR:
            return {
                ...initialStateArray,
                error: err,
                data: null,
                loading: false,
            };
        default:
            return state;
    }
};

export { 
    storeDashboardDataReducers,
    splProductTargetReducers,
    productDiscoveryTokenReducers,
    storeContentVideoDetailsReducers,
    storeContentVideoDownloadReducers,
}; 
